import PagesLayout from "../../components/global/PagesLayout";
import PageHeader from "../../components/global/PageHeader";
import Breadcrumbs from "../../components/global/Breadcrumbs";
import Content from "../../components/privacyPolicy/Content";

const PrivacyPolicy = () => {
  return (
    <PagesLayout>
      <PageHeader title="Privacy Policy" />
      <Breadcrumbs title="Privacy Policy" />
      <Content />
      <Breadcrumbs title="Privacy Policy" />
    </PagesLayout>
  );
};

export default PrivacyPolicy;
